import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import style from "../components/slideshow.module.scss"
export default function Slideshow({ image }) {
  return (
    <div className={style.wrapper}>
      {/* <Img fluid={data.allFile.edges[0].node.childImageSharp.fluid} /> */}
      {console.log(image)}
      <AnimatePresence>
        <motion.div
          key={image}
          className={style.image}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          // transition={{ duration: 1 }}
          style={{ backgroundImage: `url(${image})` }}
        ></motion.div>
      </AnimatePresence>
      {/* <Img
        fluid={data.allFile.edges[seconds].node.childImageSharp.fluid}
        fadeIn={true}
        durationFadeIn={5000}
        style ={{height: '100%'}}
        imgStyle = {{height: '100%'}}
      /> */}
    </div>
  )
}
